import { type FC } from 'react';

import { LearnerProgressBar } from '@/src/components/atoms/LearnerProgressBar';
import { AssignedActivityStatusBar } from '@/src/components/molecules/AssignedActivityStatusBar';

import { isProgressSlot, isStatusSlot, type ProgressSlot, type StatusSlot } from './helpers';

export type LeftSlotProps = ProgressSlot | StatusSlot;

/**
 * Represents the modular block in the lower left corner of the card.
 * Typically used for indicating learner progress or general status information for assigned
 * content.
 */
export const LeftSlot: FC<LeftSlotProps> = props => {
  if (isProgressSlot(props)) {
    const { approved, pending, returned } = props;

    return <LearnerProgressBar progress={{ approved, pending, returned }} />;
  }

  if (isStatusSlot(props)) {
    const { dueDate, score, status, userIds } = props;

    return (
      <AssignedActivityStatusBar
        dueDate={dueDate}
        score={score}
        status={status}
        userIds={userIds}
      />
    );
  }

  return null;
};
